export default __webpack_public_path__ + "static/media/kamila.a8727787.jpg";